import { createFileRoute } from "@tanstack/react-router";
import { RulesPage } from "./-rules/rules.page";

export const Route = createFileRoute("/content/rules/")({
  component: RulesPage,
});
